// extracted by mini-css-extract-plugin
export default {"text-body-1":"Download_text-body-1__SzJaA","text-body-3":"Download_text-body-3__CEgUO","download":"Download_download__hAdN1","upDown":"Download_upDown__fHQhu"};